export enum DoorType {
  UNKNOWN_DOOR_TYPE = 'UNKNOWN_DOOR_TYPE',
  NORMALLY_OPENED = 'NORMALLY_OPENED',
  NORMALLY_CLOSED = 'NORMALLY_CLOSED'
}
